import React, { useEffect } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { faExclamationTriangle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ATOAuthError = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get('error') || 'Unknown error occurred';

  useEffect(() => {
    // Auto-close the window after 5 seconds
    const timer = setTimeout(() => {
      window.close();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    window.close();
  };

  return (
    <Container className="mt-5">
      <div className="text-center">
        <FontAwesomeIcon 
          icon={faExclamationTriangle} 
          size="4x" 
          className="text-danger mb-3" 
        />
        <h2 className="text-danger mb-3">ATO Authentication Failed</h2>
        <Alert variant="danger">
          <strong>Error:</strong> {error}
          <br />
          <br />
          <strong>Common causes:</strong>
          <ul className="text-start mt-2">
            <li>Invalid ATO Client ID or Client Secret</li>
            <li>Incorrect redirect URI configuration</li>
            <li>ATO API credentials not properly set up</li>
            <li>Network connectivity issues</li>
          </ul>
        </Alert>
        <p className="text-muted">
          This window will close automatically in a few seconds.
        </p>
        <Button variant="primary" onClick={handleClose}>
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          Close Window
        </Button>
      </div>
    </Container>
  );
};

export default ATOAuthError;
